module.exports = __webpack_public_path__ + "img/memoji-2.3eafa30f.svg";